import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const dialogDefaultVariants = {
  "size": "large",
  "stacked": false,
  "align": "start"
}
const dialogCompoundVariants = []

const dialogSlotNames = [
  [
    "overlay",
    "Dialog__overlay"
  ],
  [
    "modal",
    "Dialog__modal"
  ],
  [
    "panel",
    "Dialog__panel"
  ],
  [
    "header",
    "Dialog__header"
  ],
  [
    "close",
    "Dialog__close"
  ],
  [
    "illustration",
    "Dialog__illustration"
  ],
  [
    "titleGroup",
    "Dialog__titleGroup"
  ],
  [
    "title",
    "Dialog__title"
  ],
  [
    "description",
    "Dialog__description"
  ],
  [
    "body",
    "Dialog__body"
  ],
  [
    "actions",
    "Dialog__actions"
  ]
]
const dialogSlotFns = /* @__PURE__ */ dialogSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, dialogDefaultVariants, getSlotCompoundVariant(dialogCompoundVariants, slotName))])

const dialogFn = memo((props = {}) => {
  return Object.fromEntries(dialogSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const dialogVariantKeys = [
  "size",
  "stacked",
  "align"
]
const getVariantProps = (variants) => ({ ...dialogDefaultVariants, ...compact(variants) })

export const dialog = /* @__PURE__ */ Object.assign(dialogFn, {
  __recipe__: false,
  __name__: 'dialog',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: dialogVariantKeys,
  variantMap: {
  "size": [
    "large",
    "small"
  ],
  "stacked": [
    "true",
    "false"
  ],
  "align": [
    "start",
    "center"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, dialogVariantKeys)
  },
  getVariantProps
})